"use client"

import { useTranslations } from 'next-intl';
import PageLayout from '@/components/PageLayout';
import { Link } from '@/i18n/navigation';
import { Button } from '@/components/ui/button';

export default function NotFoundPage() {
  const t = useTranslations('NotFoundPage');

  return (
    <PageLayout>
      <div className='flex justify-center items-center flex-col py-64 gap-4'>
        <h1 className='text-4xl text-black'>{t('title')}</h1>
        <p className='max-w-[60ch] text-center'>{t('description')}</p>
        <Link href="/">
          <Button>{t('cta')}</Button>
        </Link>
      </div>
    </PageLayout>
  );
}
